import "../node_modules/regenerator-runtime/runtime";
import {UI} from "../stem-core/src/ui/UIBase";
window.UI = UI;

export * from "./State";
export * from "./InitIFrameApp";
